module.exports = __webpack_public_path__ + "img/1.ad74bf85.jpg";